import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppContext from '../../context/Context';

const StudentThemeToggle = () => {
  const { isDark, setIsDark } = useContext(AppContext);

  return (
    <button
      type="button"
      className="psi-theme-toggle psi-theme-toggle--auth"
      onClick={() => setIsDark(!isDark)}
      aria-label={isDark ? "Kunduzgi rejimga o'tish" : "Tungi rejimga o'tish"}
      aria-pressed={isDark}
      title={isDark ? "Kunduzgi rejimga o'tish" : "Tungi rejimga o'tish"}
    >
      <FontAwesomeIcon icon={isDark ? 'sun' : 'moon'} />
    </button>
  );
};

export default StudentThemeToggle;
